import { SIGNALING_STATUS } from "../../constants/signaling";

export const SET_SIGNALING_STATUS = "SET_SIGNALING_STATUS";
export const SET_USER_STREAM = "SET_USER_STREAM";
export const SET_PARTNER_STREAM = "SET_PARTNER_STREAM";
export const STOP_USER_STREAM = "STOP_USER_STREAM";
export const STOP_PARTNER_STREAM = "STOP_PARTNER_STREAM";
export const SET_SIGNALING_SESSION_HOLD = "SET_SIGNALING_SESSION_HOLD";

export type SignalingStateType = {
  status: SIGNALING_STATUS | undefined;
  userStream: MediaStream | undefined;
  partnerStream: MediaStream | undefined;
  sessionHold: boolean;
};

export type SetSignalingStatusActionType = {
  type: typeof SET_SIGNALING_STATUS;
  payload: SIGNALING_STATUS | undefined;
};
export type SetUserStreamActionType = {
  type: typeof SET_USER_STREAM;
  payload: MediaStream;
};
export type SetPartnerStreamActionType = {
  type: typeof SET_PARTNER_STREAM;
  payload: MediaStream;
};
export type StopUserStreamActionType = {
  type: typeof STOP_USER_STREAM;
};
export type StopPartnerStreamActionType = {
  type: typeof STOP_PARTNER_STREAM;
};
export type SetSignalingSessionHoldActionType = {
  type: typeof SET_SIGNALING_SESSION_HOLD;
  payload: boolean;
};

export type SignalingActionTypes =
  | SetSignalingStatusActionType
  | SetUserStreamActionType
  | SetPartnerStreamActionType
  | StopUserStreamActionType
  | StopPartnerStreamActionType
  | SetSignalingSessionHoldActionType;
